import { Button, Modal, Popover, Radio, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AiFillCaretRight } from "react-icons/ai";
import { BiArrowBack } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { FiArrowRight, FiMapPin, FiSearch } from "react-icons/fi";
import { IoIosCloseCircle } from "react-icons/io";
import { RiArrowDownSLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { AuthModalContext } from "../../Contexts/AuthModalContext";
import { CartContext } from "../../Contexts/CartContext";
import { ConfigContext } from "../../Contexts/ConfigContext";
import { useSubCategories } from "../../Hooks/useProductsBySubCategory";
import { clearSessionStorage } from "../../utils/storage";
import { FeatureFlag } from "../FeatureFlag/FeatureFlag";
import { categoryMiddleData } from "../Layout/data";
import styles from "./AppHeader.module.scss";
import menu_btn from "../Layout/images/menu_btn.svg";

const AppHeader = ({ mobileSearch, setMobileSearch }) => {
    const { cartItems } = useContext(CartContext);
    const navigate = useNavigate();
    const { user, setIsAuthenticated, setUser, location, isAuthenticated } = useContext(AuthContext);
    const { showLocModal, setShowLocModal } = useContext(ConfigContext);
    const { openSignIn } = useContext(AuthModalContext);

    const guest_user = JSON.parse(localStorage.getItem("guest_user"));

    const [followPopShow, setFollowPopShow] = useState(false);
    const { categories: subcategories } = useSubCategories();
    const [searchTerm, setSearchTerm] = useState("");
    const [searchCategory, setSearchCategory] = useState("");
    const [showLangModal, setShowLangModal] = useState(false);

    // set search term from url params
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const searchTerm = params.get("searchTerm");
        const searchCategory = params.get("searchCategory");
        setSearchTerm(searchTerm);
        setSearchCategory(searchCategory);
    }, []);

    const searchHandler = (e) => {
        e.preventDefault();
        if (!searchTerm) return;
        navigate(`/search?searchTerm=${searchTerm}${searchCategory ? "&searchCategory=" + searchCategory : ""}`);
        // store search term in local storage as an array of strings for recent searches, but store only 12 recent searches
        let recentSearches = JSON.parse(window.localStorage.getItem("recentSearches")) || [];
        if (recentSearches.length >= 12) {
            recentSearches.pop();
        }
        recentSearches.unshift(searchTerm);
        // remove duplicates
        recentSearches = [...new Set(recentSearches)];
        window.localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
    };

    const logoutHandler = () => {
        // keeps the cookie consent and the delivery location - asking for both
        // again on the next sign-in is what made logging back in annoying
        clearSessionStorage();
        setIsAuthenticated(false);
        setUser(null);
        window.location.reload();
    };

    return (
        <>
            <div className={styles.sticky_header_wrapper}>
                <div className={styles.topbar__wrapper}>
                    <div className={styles.topbar + " container"}>
                        <div className={styles.topbar__left}>
                            <div onClick={() => navigate("/our-story")}>
                                <img src="/icon/desktop/tb_l_1.svg" alt="About Us" />
                                <span>About Us</span>
                            </div>

                            <div onClick={() => navigate("/quality-authenticity")}>
                                <img src="/icon/desktop/tb_l_2.svg" alt="Authenticity Check" />
                                <span>Our Quality Standard</span>
                            </div>
                        </div>

                    <ul>
                        <FeatureFlag name="desiFamily">
                            <li>
                                <img src="/icon/desktop/desi_family_top_bar_icon.svg" alt="" />
                                Desi Family
                            </li>
                        </FeatureFlag>

                        <li onClick={() => navigate("/desi-hands")}>
                            <img src="/icon/desktop/desi_hands_top_bar_icon.svg" alt="" />
                            Desi Hands
                        </li>
                        <li className={styles.lang_selector_dt} onClick={() => setShowLangModal(true)}>
                            <img src="https://flagicons.lipis.dev/flags/4x3/gb.svg" alt="" />
                            EN
                        </li>

                        {guest_user ? (
                            <>
                                <li className={styles.sign_in_btn}>
                                    <Link to={"/customer/account"}>
                                        <img src="/icon/desktop/user_top_bar_icon.svg" alt="user" />
                                        Hey! Guest
                                    </Link>
                                </li>

                                <li onClick={logoutHandler} className={styles.sign_in_btn}>
                                    Logout
                                </li>
                            </>
                        ) : (
                            <>
                                {isAuthenticated ? (
                                    <>
                                        <li className={styles.sign_in_btn}>
                                            <Link to={"/customer/account"}>
                                                <img src="/icon/desktop/user_top_bar_icon.svg" alt="user" />
                                                Hey! {user.first_name}
                                            </Link>
                                        </li>

                                        <li onClick={logoutHandler} className={styles.sign_in_btn}>
                                            Logout
                                        </li>
                                    </>
                                ) : (
                                    <li className={styles.sign_in_btn} onClick={() => openSignIn()} role="button">
                                        <img src="/icon/desktop/user_top_bar_icon.svg" alt="" />
                                        Login
                                    </li>
                                )}
                            </>
                        )}
                    </ul>
                </div>
            </div>
            <div className={styles.top_header + " container"}>
                <Link to="/">
                    <img src="/logo.svg" alt="" />
                </Link>

                <div className={styles.top_header__middle}>
                    <form onSubmit={searchHandler}>
                        <input
                            placeholder="I am searching for..."
                            onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm ?? ""}
                        />
                        <button onClick={searchHandler}>
                            <BsArrowRight size={20} color={"var(--color-light)"} />
                        </button>
                    </form>
                    {location?.city && (
                        <div
                            className="d-flex pt-1 align-items-center gap-2"
                            onClick={() => {
                                setShowLocModal(true);
                            }}
                            role="button"
                        >
                            <FiMapPin size={15} />
                            <div
                                style={{
                                    fontSize: "1.5rem",
                                }}
                            >
                                <span className="fw-medium">Delivering to: </span>
                                <span className="fw-medium">
                                    {location.zip}, {location.city}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                <ul className={styles.top_header_icon_box}>
                    <Popover
                        content={FollowUsPopover}
                        title={
                            <div className={styles.landing_popover_title}>
                                <p>Social Media</p>
                                <IoIosCloseCircle onClick={() => setFollowPopShow(false)} size={16} />
                            </div>
                        }
                        trigger="click"
                        placement="bottomLeft"
                        overlayClassName="customTopBarPopover"
                        open={followPopShow}
                        onOpenChange={(newVisible) => setFollowPopShow(newVisible)}
                    >
                        <li onClick={() => setFollowPopShow(!followPopShow)}>
                            <img src="/icon/desktop/mbs-1.svg" alt="" />
                            <span>Follow Us</span>
                        </li>
                    </Popover>

                    {!location && (
                        <li onClick={() => setShowLocModal(true)}>
                            <img src="/icon/desktop/mbs-2.svg" alt="mbs-2" />
                            <span>Address</span>
                        </li>
                    )}

                    <FeatureFlag name="topHeaderMenuMyRecipesButton">
                        <li>
                            <img src="/icon/desktop/mbs-3.svg" alt="" />
                            <span>My Recipes</span>
                        </li>
                    </FeatureFlag>
                    <FeatureFlag name="myItems">
                        <li>
                            <img src="/icon/desktop/mbs-4.svg" alt="" />
                            <span>My Items</span>
                        </li>
                    </FeatureFlag>

                    <Link to="/cart-checkout">
                        <li className={styles.cart}>
                            <img src="/icon/desktop/mbs-5.svg" alt="" />
                            <span>My Cart</span>
                            {cartItems.length > 0 && <div className={styles.cart__count}>{cartItems.length}</div>}
                        </li>
                    </Link>
                </ul>
            </div>

            <section className={styles.mobile_header}>
                {mobileSearch ? (
                    <div className={styles.mobile_search}>
                        <div onClick={() => setMobileSearch(false)}>
                            <BiArrowBack size={20} />
                        </div>
                        <form onSubmit={searchHandler}>
                            <input
                                type="text"
                                placeholder="I'm searching for..."
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm ?? ""}
                            />
                            <button>
                                <FiSearch color="var(--color-light)" size={20} />
                            </button>
                        </form>
                    </div>
                ) : (
                    // Top bar for mobile
                    <>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <Link to={"/"} onClick={() => setShowLocModal(false)}>
                                <img src="/logo.svg" alt="" style={{ marginRight: "1.5rem" }} />
                            </Link>
                            <div className={styles.mobile_header__middle}></div>
                        </div>
                        <div className={styles.mobile_header__right}>
                            <Link to={"/menu"}>
                                <img src={menu_btn} alt="menu_btn" />
                            </Link>
                        </div>
                    </>
                )}
            </section>

            <section className="container">
                <ul className={styles.middle_header}>
                    {categoryMiddleData.map((category, index) => (
                        <Link
                            to={category.link}
                            key={index}
                            className={window.location.pathname === category.link ? styles.active_category : styles.inactive_category}
                        >
                            <li className={styles.cat_middle_custom_img}>
                                <img src={category.image} alt={category.alt_text} />
                                <span className="fw-bold">{category.label}</span>
                            </li>
                        </Link>
                    ))}
                </ul>
            </section>

            <section className={styles.bottom_header}>
                <div className={"container " + styles.bottom_header__body}>
                    <Link to={"/categories"}>
                        <div className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                            <div className={window.location.pathname === "/categories" ? styles.all_cat : styles.all_cat_inactive}>
                                <img
                                    src={
                                        window.location.pathname === "/categories"
                                            ? "https://desi-fresh.b-cdn.net/components_static/all_cat_active.svg"
                                            : "https://desi-fresh.b-cdn.net/components_static/all_cat_inactive.svg"
                                    }
                                    alt="all_cat"
                                />
                                <span
                                    className="fw-bold"
                                    style={{
                                        color: window.location.pathname === "/categories" ? "var(--color-primary)" : "var(--color-dark)",
                                        fontSize: "1.6rem",
                                    }}
                                >
                                    All Categories
                                </span>
                            </div>
                            <RiArrowDownSLine
                                color={window.location.pathname === "/categories" ? "var(--color-primary)" : "var(--color-dark)"}
                                size={20}
                                className="mb-2"
                            />
                        </div>
                    </Link>

                    <ul style={{ paddingTop: 7 }}>
                        {subcategories?.map((item, index) => (
                            <Link
                                to={`/category/${item.slug}_${item.id}`}
                                key={index}
                                className={
                                    window.location.pathname === `/category/${item.slug}_${item.id}`
                                        ? styles.active_category
                                        : styles.inactive_category
                                }
                            >
                                <li className={styles.cat_middle_custom_img}>
                                    <img src={item.image} alt={index} />
                                    <span className="fw-bold">{item.name}</span>
                                </li>
                            </Link>
                        ))}
                    </ul>
                    <div className={styles.arrow}>
                        <Link to={"/categories"}>
                            <FiArrowRight color={"var(--color-dark)"} size={20} />
                        </Link>
                    </div>
                </div>
            </section>
            </div>

            {/*LangSelect Modal*/}
            <Modal open={showLangModal} footer={null} centered={true} onCancel={() => setShowLangModal(false)}>
                <div className={styles.lang_modal}>
                    <b>Select & save your language</b>

                    <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
                        <Radio style={{ display: "flex", alignItems: "center" }} checked={true}>
                            <div className={styles.lang_modal__radio}>
                                <img src="https://flagicons.lipis.dev/flags/4x3/gb.svg" alt="" />
                                <span>EN</span>
                            </div>
                        </Radio>
                        <Radio
                            style={{ display: "flex", alignItems: "center" }}
                            checked={false}
                            onClick={() => message.info("Deutsch will be available soon!")}
                        >
                            <div className={styles.lang_modal__radio}>
                                <img src="https://flagicons.lipis.dev/flags/4x3/de.svg" alt="" />
                                <span>DE</span>
                            </div>
                        </Radio>
                    </div>

                    <Button type={"primary"} onClick={() => setShowLangModal(false)}>
                        Save
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default AppHeader;

const FollowUsPopover = () => {
    const items = [
        {
            title: "Facebook",
            icon: "/layout-icons/fb_icon.svg",
            link: "https://www.facebook.com/dfresh.de",
        },
        {
            title: "Instagram",
            icon: "/layout-icons/insta_icon.svg",
            link: "https://www.instagram.com/dfresh_de",
        },
        {
            title: "YouTube",
            icon: "/layout-icons/youtube_icon.svg",
            link: "https://www.youtube.com/channel/UCPZDCA-MzmVJKRQ4FvCclCw",
        },
        {
            title: "Linkedin",
            icon: "/layout-icons/linkedin_icon.svg",
            link: "https://www.linkedin.com/company/desi-fresh",
        },
        {
            title: "Twitter",
            icon: "/layout-icons/twitter_icon.svg",
            link: "https://twitter.com/DesiFresh_de",
        },
    ];
    return (
        <>
            {items.map((item, i) => (
                <a href={item.link} target="_blank" rel="noreferrer" key={i} className={styles.landing_popover_content}>
                    <img src={item.icon} alt={item.id} />
                    <p> {item.title} </p>
                    <AiFillCaretRight size={13} />
                </a>
            ))}
        </>
    );
};
